import React from "react";

export const StaticTextLabel = (props) => {
    const {children} = props;
    return (
        <span className="static-text" style={{margin: '10px'}}>{children}</span>
    )
}